import { jsx as t, jsxs as c } from "react/jsx-runtime";
import d from "@mui/material/Box";
import m from "@mui/material/Grid";
import s from "@mui/material/Typography";
import { makeStyles as f } from "tss-react/mui";
import { ceoMessage as g } from "@lumirental/lumi-web-shared/lib/constants/IR/content";
import { useConfigContext as x } from "@lumirental/lumi-web-shared/lib/contexts/Config.context";
import { useLanguageContext as y } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import b from "@lumirental/lumi-web-shared/lib/utils/cdnLinks/getPublicCDNLink";
import v from "./CEOMessage.style.js";
const h = f()(v), N = ({
  language: e,
  data: o
}) => {
  const { classes: r } = h(), { title: n, subTitle: a, text: i } = o;
  return /* @__PURE__ */ c(d, { className: r.content, children: [
    /* @__PURE__ */ t(s, { variant: "body1", className: r.text, children: i[e] }),
    /* @__PURE__ */ t(s, { variant: "h5", className: r.title, children: n[e] }),
    /* @__PURE__ */ t(s, { variant: "body1", className: r.subTitle, children: a[e] })
  ] });
}, A = ({ data: e }) => {
  const { classes: o } = h(), { language: r } = y(), { appEnv: n } = x(), { heading: a, avatarImg: i, list: l } = e;
  return /* @__PURE__ */ c(
    m,
    {
      container: !0,
      columnSpacing: { xs: 0, sm: 11 },
      direction: "row",
      sx: {
        justifyContent: "center",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ t(m, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ t(d, { className: o.avatarImg, children: /* @__PURE__ */ t(
          "img",
          {
            src: b(i, n),
            alt: "Lumi Author Img"
          }
        ) }) }),
        /* @__PURE__ */ c(m, { item: !0, xs: 12, sm: 6, children: [
          /* @__PURE__ */ t(
            s,
            {
              variant: "h2",
              className: o.heading,
              sx: { marginBottom: 4 },
              children: a[r]
            }
          ),
          l && l.map((u) => {
            const { id: p } = u;
            return /* @__PURE__ */ t(N, { language: r, data: u }, p);
          })
        ] })
      ]
    }
  );
}, C = () => /* @__PURE__ */ t(A, { data: g }), G = C;
export {
  G as default
};
